// extracted by mini-css-extract-plugin
module.exports = {"wrap":"_b7787ed","title":"_60d2fe2","description":"_c041c24"};